export default __webpack_public_path__ + "static/media/LSBULogo.7079aafc.png";